import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './components/login.js';
import 'uikit/dist/css/uikit.min.css';
import LoginState from './components/context/LoginState.js';
import TestButton from './test.js';
import NotFound from './components/NotFound.js';



function App() {
  return (
    <Router>
       <LoginState>
      <Routes>
       
      <Route path="/hotel/:hotelName" element={<Login />} />
        <Route path="/404" element={<NotFound />} />
        <Route path="*" element={<NotFound />} /> {/* Catch-all for undefined routes */}
        <Route path="/button" element={<TestButton />} />
      </Routes>
      </LoginState>
    </Router>
  );
}

export default App;
